(function () {
  function updatePrice(priceEl, formattedPrice) {
    if (!priceEl || !formattedPrice) return;

    var display =
      priceEl.querySelector('[data-ss-edition-price-display]') ||
      priceEl.querySelector('.price') ||
      priceEl;
    display.textContent = formattedPrice;

    var compareGroups = priceEl.querySelectorAll('.compare-at-price, .price-item--regular.compare-at-price');
    compareGroups.forEach(function (el) {
      el.closest('.price__sale, .price-item__group')?.classList.add('price__hidden');
    });
    var regular = priceEl.querySelector('.price__regular');
    if (regular) regular.classList.remove('price__hidden');
  }

  function initEditionPicker(picker) {
    if (picker.dataset.ssEditionReady) return;
    picker.dataset.ssEditionReady = '1';

    var card =
      picker.closest('[data-ss-bundle-card]') ||
      picker.closest('product-card') ||
      picker.closest('.ss-home-card') ||
      picker.parentElement;
    if (!card) return;

    var priceEl = card.querySelector('[data-ss-bundle-price]') || card.querySelector('.ss-home-card__price');
    var addBtn = card.querySelector('[data-ss-bundle-add]');
    var formInput = card.querySelector('form[action="/cart/add"] input[name="id"]');
    var links = card.querySelectorAll(
      '[data-ss-bundle-link], .ss-home-card__title, .ss-home-card__media, .product-card__link, [ref="productTitleLink"]'
    );

    picker.querySelectorAll('[data-ss-edition-option]').forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var newId = pill.dataset.variantId;
        if (!newId) return;

        var oldId = addBtn ? addBtn.dataset.variantId : formInput ? formInput.value : '';

        picker.querySelectorAll('[data-ss-edition-option]').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');

        updatePrice(priceEl, pill.dataset.variantPrice);

        if (formInput) formInput.value = newId;

        if (addBtn) {
          addBtn.dataset.variantId = newId;
          if (pill.dataset.variantPriceCents) {
            addBtn.dataset.variantPriceCents = pill.dataset.variantPriceCents;
          }
          var available = pill.dataset.variantAvailable === 'true';
          addBtn.disabled = !available;
          if (!available) {
            addBtn.classList.remove('is-added');
            addBtn.textContent = 'Sold out';
          } else if (!addBtn.classList.contains('is-added')) {
            addBtn.textContent = addBtn.dataset.defaultLabel || addBtn.textContent;
          }
        }

        links.forEach(function (link) {
          var href = link.getAttribute('href');
          if (!href || href === '#') return;
          var base = href.split('?')[0];
          link.setAttribute('href', base + '?variant=' + newId);
        });

        card.dispatchEvent(
          new CustomEvent('ss-edition-change', {
            bubbles: true,
            detail: { oldId: oldId, newId: newId, available: pill.dataset.variantAvailable === 'true' },
          })
        );
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ss-bundle-edition]').forEach(initEditionPicker);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
